import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchCryptoTransactionsData(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/jobs/cryptoTransactions', {
    query: {}
  });
  yield put({
    type: 'SET_CRYPTO_TRANSACTIONS_DATA',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeFirst('FETCH_CRYPTO_TRANSACTIONS_DATA', fetchCryptoTransactionsData),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/CryptoTransactions/CryptoTransactions.sagas.js